import React from 'react';
import classNames from 'classnames';
import Icon from '../icon';
import getLabelStyles from './helpers/get-label-styles';
import { APPEARANCES, LABEL_POSITIONS, LABEL_GAPS, VARIABLES, COLORS } from './constants';

// @ts-ignore TS(2322): Type 'null' is not assignable to type 'string'.
function Highlighter({
  elementBounds,
  withNegativeIndent = false,
  visible,
  iconGlyph = '',
  label = '',
  appearance = APPEARANCES.default,
  color = COLORS.default,
  labelPosition = LABEL_POSITIONS.leftBottom,
  labelGap = LABEL_GAPS.small,
  fullwidthLabel = false,
  // @ts-ignore TS(2322): Type 'null' is not assignable to type 'string | undefined'.
  clipPath = null,
}) {
  const { width, height, left, top } = elementBounds;
  const indent = withNegativeIndent ? `${VARIABLES.borderIndent} * -1` : VARIABLES.borderIndent;
  // @ts-ignore TS(2345): Argument of type 'number | undefined' is not assig... Remove this comment to see the full error message
  const highlighterWidth = `calc(${Math.round(width)}px + ${indent} * 2)`;
  // @ts-ignore TS(2345): Argument of type 'number | undefined' is not assig... Remove this comment to see the full error message
  const highlighterHeight = `calc(${Math.round(height)}px + ${indent} * 2)`;
  // @ts-ignore TS(2345): Argument of type 'number | undefined' is not assig... Remove this comment to see the full error message
  const offsetX = `calc(${Math.round(left)}px - ${indent} - ${VARIABLES.borderWidth})`;
  // @ts-ignore TS(2345): Argument of type 'number | undefined' is not assig... Remove this comment to see the full error message
  const offsetY = `calc(${Math.round(top)}px - ${indent} - ${VARIABLES.borderWidth})`;

  const highlighterStyle = {
    // @ts-ignore TS(2532): Object is possibly 'undefined'.
    bottom: `${-top}px`,
    // @ts-ignore TS(2532): Object is possibly 'undefined'.
    height: `calc(${top + height}px + ${indent} + ${VARIABLES.borderWidth})`,
  };
  const highlighterMaskStyle = {
    width: highlighterWidth,
    height: highlighterHeight,
    left: offsetX,
    top: offsetY,
    ...(clipPath && { clipPath }),
  };
  const labelStyles = getLabelStyles(elementBounds, indent, labelPosition, fullwidthLabel);

  const highlighterClassName = classNames(
    'ws-ui-highlighter',
    `ws-ui-highlighter--${appearance}`,
    `ws-ui-highlighter--${color}`,
    {
      'ws-ui-highlighter--visible': visible,
    }
  );
  const labelClassName = classNames(
    'ws-ui-highlighter__label',
    `ws-ui-highlighter__label--gap-${labelGap}`,
    `ws-ui-highlighter__label--${labelPosition}`
  );

  return (
    <div className={highlighterClassName} style={highlighterStyle}>
      <div className="ws-ui-highlighter__mask" style={highlighterMaskStyle} />
      {label && (
        <div className={labelClassName} style={labelStyles}>
          {/* @ts-ignore TS(2322): Type '{ className: string; glyph: string; }' is no... Remove this comment to see the full error message */}
          {iconGlyph && <Icon className="ws-ui-highlighter__label-icon" glyph={iconGlyph} />}
          <span className="ws-ui-highlighter__label-description">{label}</span>
        </div>
      )}
    </div>
  );
}

export default Highlighter;
